module.exports = __webpack_public_path__ + "img/27.2876c8fe.jpg";